module.exports = __webpack_public_path__ + "static/media/amthf.df2b4c44.pdf";